import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import {Stack} from '@mui/material';
import * as Sentry from '@sentry/browser';
import {array, bool, func, number, object} from 'prop-types';
import React from 'react';
import EmptyMessage from '../common/EmptyMessage.jsx';
import ReservationCard from './ReservationCard.jsx';
import Loading from '@components/common/LoadingMessage';

const CompletedTabContent = ({
  reservations,
  loadingReservations,
  productCount,
  products,
  features,
  loadingFeatures,
  selectedFeatureRefs,
  setSelectedFeatureRefs,
  setZoomedFeature,
  collection,
}) => {
  if (loadingReservations) {
    return <Loading suffix="reservations" />;
  }

  if (!productCount && !loadingReservations) {
    return (
      <EmptyMessage
        height="100%"
        icon={<Inventory2OutlinedIcon />}
        title="No quota reservations"
        description="Please select a data product to start quota reservation"
      />
    );
  }

  return (
    <Stack direction="column" spacing={2}>
      {Object.keys(reservations).map(productId => {
        const product = products.find(p => {
          return p.id === Number(productId);
        });

        if (!product) {
          Sentry.captureMessage(`Product not found for id: ${productId}`);

          return false;
        }

        return (
          <ReservationCard
            key={productId}
            product={product}
            reservations={reservations[productId]}
            features={features}
            loadingFeatures={loadingFeatures}
            selectedFeatureRefs={selectedFeatureRefs[productId]}
            setSelectedFeatureRefs={features => {
              setSelectedFeatureRefs(prevSelections => ({
                ...prevSelections,
                [productId]: features,
              }));
            }}
            onZoomToFeature={setZoomedFeature}
            collection={collection}
          />
        );
      })}
    </Stack>
  );
};

CompletedTabContent.propTypes = {
  reservations: object,
  productCount: number,
  products: array,
  features: array,
  loadingFeatures: bool,
  selectedFeatureRefs: object,
  setSelectedFeatureRefs: func,
  setZoomedFeature: func,
  collection: object,
  loadingReservations: bool,
};

export default CompletedTabContent;
